import { Component, inject } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-legalization-registry-tabs-container',
  templateUrl: './legalization-registry-tabs-container.component.html',
  styleUrls: ['./legalization-registry-tabs-container.component.scss'],
  standalone: false
})
export class LegalizationRegistryTabsContainerComponent {
  private translateService = inject(TranslateService);


  public LegalizationListType = LegalizationListType;

  listType: LegalizationListType = LegalizationListType.Legalizations;


  constructor() {
  }

  onTabChanged(event: MatTabChangeEvent): void {
    const map = new Map<string, LegalizationListType>([
      [this.translateService.instant('Legalization.Register.LegalizationsProcesses'), LegalizationListType.Legalizations],
      [this.translateService.instant('Legalization.Register.Documents'), LegalizationListType.Documents]
    ]);

    if (!map.has(event.tab.textLabel)) {
      return;
    }

    const index = map.get(event.tab.textLabel);

    if (index === undefined) {
      return;
    }

    this.listType = index;
  }
}


export enum LegalizationListType {
  Legalizations = 1,
  Documents = 2
}
